var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 192,
    height: 192,
    viewBox: "0,0,256,256",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 24.8,
    y1: 36.91,
    x2: 24.8,
    y2: -2.028,
    gradientUnits: "userSpaceOnUse",
    id: "color-1_NQHTIO3UIvs9_gr1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    stopColor: "#FFF584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#FDBE26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCAB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5.913,
    y1: 36.5,
    x2: 37.913,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse",
    id: "color-2_NQHTIO3UIvs9_gr2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DAA6FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA6FF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 23.217,
    y1: 33.672,
    x2: 8.298,
    y2: 42.366,
    gradientUnits: "userSpaceOnUse",
    id: "color-3_NQHTIO3UIvs9_gr3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F5EBFF",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA6FF",
    stopOpacity: 0.4
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.822,40.664c-1.475,0.125 -2.791,-0.556 -3.725,-1.578l0.007,0.023c0.878,1.245 2.222,1.891 3.896,1.891h27c-2.209,0 -5,-1 -5,-6v-2c0,-0.552 -0.448,-1 -1,-1h-16.75v3.681c0,4.462 -3.648,4.905 -4.428,4.983z",
    fill: "#AC11EF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.644,40.328c-1.406,0.174 -2.76,-0.395 -3.69,-1.481l0.022,0.077c0.871,1.37 2.268,2.076 4.024,2.076h27c-2.209,0 -5,-1 -5,-6v-2c0,-0.552 -0.448,-1 -1,-1h-17.5v3.999c0,3.498 -2.848,4.172 -3.856,4.329z",
    fill: "#AC11EF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.466,39.993c-1.337,0.224 -2.73,-0.234 -3.654,-1.384l0.033,0.125c0.856,1.505 2.314,2.266 4.155,2.266h27c-2.209,0 -5,-1 -5,-6v-2c0,-0.552 -0.448,-1 -1,-1h-18.25v4.316c0,2.535 -2.048,3.441 -3.284,3.677z",
    fill: "#AC11EF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.288,39.657c-1.267,0.272 -2.694,-0.072 -3.614,-1.282c0.821,1.738 2.349,2.625 4.326,2.625h27c-2.209,0 -5,-1 -5,-6v-2c0,-0.552 -0.448,-1 -1,-1h-19v4.633c0,1.572 -1.248,2.709 -2.712,3.024z",
    fill: "#AC11EF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.438,6h27.114c1.5,0 3.448,1.126 3.448,3.876v2.037c0,0.324 -0.263,0.587 -0.587,0.587h-25.951c-0.324,0 -0.587,-0.263 -0.587,-0.587v-1.788c0,-3.438 -1.919,-4.125 -3.437,-4.125z",
    fill: "#E59D05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.438,6c-1.899,0 -3.438,1.539 -3.438,3.438v25.927c0,5.423 -4.447,5.635 -5,5.635h27c2.761,0 5,-2.239 5,-5v-26.125c0,-3.729 3.221,-3.875 3.601,-3.875z",
    fill: "url(#color-1_NQHTIO3UIvs9_gr1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,16c0,-0.552 0.448,-1 1,-1h13c0.552,0 1,0.448 1,1c0,0.552 -0.447,1 -1,1h-13c-0.552,0 -1,-0.448 -1,-1zM28,25h-9c-0.552,0 -1,0.448 -1,1v0c0,0.552 0.448,1 1,1h9c0.552,0 1,-0.448 1,-1v0c0,-0.552 -0.447,-1 -1,-1zM32,20h-13c-0.552,0 -1,0.448 -1,1v0c0,0.552 0.448,1 1,1h13c0.552,0 1,-0.448 1,-1v0c0,-0.552 -0.447,-1 -1,-1z",
    fill: "#FD9C20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35.364c0,5.424 -4.447,5.636 -5,5.636h27c-2.064,0 -4.6,-1.295 -4.6,-6v-2c0,-0.773 -0.627,-1.4 -1.4,-1.4h-16z",
    fill: "#F724FF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35.364c0,5.424 -4.447,5.636 -5,5.636h27c-1.919,0 -4.2,-1.59 -4.2,-6v-2c0,-0.993 -0.807,-1.8 -1.8,-1.8h-16z",
    fill: "#F724FF",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35.364c0,5.424 -4.447,5.636 -5,5.636h27c-1.774,0 -3.8,-1.885 -3.8,-6v-2c0,-1.214 -0.987,-2.2 -2.2,-2.2h-16z",
    fill: "#F724FF",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35.364c0,5.424 -4.447,5.636 -5,5.636h27c-1.628,0 -3.4,-2.18 -3.4,-6v-2c0,-1.434 -1.166,-2.6 -2.6,-2.6h-16z",
    fill: "#F724FF",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,35.364c0,5.424 -4.447,5.636 -5,5.636h27c-1.483,0 -3,-2.476 -3,-6v-2c0,-1.654 -1.346,-3 -3,-3h-16z",
    fill: "#F724FF",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,41h-27c-3,0 -5,-2 -5,-6v-2c0,-0.552 0.448,-1 1,-1h25c0.552,0 1,0.448 1,1v2c0,5 2.791,6 5,6z",
    fill: "url(#color-2_NQHTIO3UIvs9_gr2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,32.5c0.276,0 0.5,0.224 0.5,0.5v2c0,2.965 0.947,4.608 2.145,5.5h-23.645c-2.902,0 -4.5,-1.953 -4.5,-5.5v-2c0,-0.276 0.224,-0.5 0.5,-0.5h25M28,32h-25c-0.552,0 -1,0.448 -1,1v2c0,4 2,6 5,6h27c-2.209,0 -5,-1 -5,-6v-2c0,-0.552 -0.448,-1 -1,-1z",
    fill: "url(#color-3_NQHTIO3UIvs9_gr3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.2dbb5cc2ad6ebea8ab38465050f2a13d.svg";
export { ForwardRef as ReactComponent };